import e from "./HierarchicalMenu.vue_rollup-plugin-vue=script.js";
export default (function (e, t, n, r, s, o, i, a) {
  var c = ("function" == typeof n ? n.options : n) || {};
  return c.__file = "HierarchicalMenu.vue", c.render || (c.render = e.render, c.staticRenderFns = e.staticRenderFns, c._compiled = !0, s && (c.functional = !0)), c._scopeId = r, c;
})({
  render: function render() {
    var e = this,
        t = e.$createElement,
        n = e._self._c || t;
    return e.state ? n("div", {
      class: [e.suit(), !e.state.canRefine && e.suit("", "noRefinement")]
    }, [e._t("default", function () {
      return [n("hierarchical-menu-list", {
        attrs: {
          items: e.state.items,
          level: 0,
          refine: e.state.refine,
          createURL: e.state.createURL,
          suit: e.suit
        }
      }), e._v(" "), e.showMore ? n("button", {
        class: [e.suit("showMore"), !e.state.canToggleShowMore && e.suit("showMore", "disabled")],
        attrs: {
          disabled: !e.state.canToggleShowMore
        },
        on: {
          click: function click(t) {
            return t.preventDefault(), e.state.toggleShowMore.apply(null, arguments);
          }
        }
      }, [e._t("showMoreLabel", function () {
        return [e._v("\n        " + e._s(e.state.isShowingMore ? "Show less" : "Show more") + "\n      ")];
      }, {
        isShowingMore: e.state.isShowingMore
      })], 2) : e._e()];
    }, {
      items: e.state.items,
      canRefine: e.state.canRefine,
      canToggleShowMore: e.state.canToggleShowMore,
      isShowingMore: e.state.isShowingMore,
      refine: e.state.refine,
      createURL: e.state.createURL,
      toggleShowMore: e.state.toggleShowMore,
      sendEvent: e.state.sendEvent
    })], 2) : e._e();
  },
  staticRenderFns: []
}, 0, e, void 0, !1);